import { Box, Tab, Tabs } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { getSettingsList } from '@app/shared';
import { PageHeader } from '../../components/PageHeader';
import { SettingsListBody } from '../configuration/SettingsListPage';
import { CarrierDetailsTab } from './CarrierDetailsTab';
import { PlansTab } from './PlansTab';
import { TopupsTab } from './TopupsTab';

/** Tabs of the reference's Plan Config screen, in its order. */
const TABS = [
  { value: 'plan', label: 'Plan' },
  { value: 'topup', label: 'Topup' },
  { value: 'linked', label: 'Linked Topup' },
  { value: 'carrier', label: 'Carrier Details' },
] as const;
const LINKED_TOPUPS = getSettingsList('linked-topups')!;
type TabValue = (typeof TABS)[number]['value'];

/** Plan Config (PC232). The active tab lives in `?tab=` so it survives a reload and can be linked to. */
export function PlanConfigPage() {
  const [params, setParams] = useSearchParams();
  const requested = params.get('tab');
  const tab: TabValue = TABS.find((t) => t.value === requested)?.value ?? 'plan';

  return (
    <Box>
      <PageHeader title="Plan Config" code="PC232" />
      <Tabs
        value={tab}
        onChange={(_e, value: TabValue) => setParams({ tab: value })}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ mb: 1.5, borderBottom: 1, borderColor: 'divider' }}
      >
        {TABS.map((t) => (
          <Tab key={t.value} value={t.value} label={t.label} />
        ))}
      </Tabs>
      {tab === 'plan' ? <PlansTab /> : null}
      {tab === 'topup' ? <TopupsTab /> : null}
      {tab === 'linked' ? <SettingsListBody def={LINKED_TOPUPS} /> : null}
      {tab === 'carrier' ? <CarrierDetailsTab /> : null}
    </Box>
  );
}
